import React, { useState } from "react";


const Ourclient = () => {
  const [hoveredClient, setHoveredClient] = useState(null);

   const clientLogos = [
'/assets/img/bg/Poojara-logo-1753099967449.png', '/assets/img/bg/Reliance_Digital.svg.png', '/assets/img/bg/logo.svg',
'/assets/img/bg/Logosss.webp', '/assets/img/bg/Babulime.png', '/assets/img/bg/Tata_Motors_Logo.svg.png',
'assets/img/bg/WhatsApp Image 2025-09-08 at 2.44.48 PM(5).jpeg','assets/img/bg/WhatsApp Image 2025-09-08 at 2.44.48 PM(4).jpeg',
'assets/img/bg/WhatsApp Image 2025-09-08 at 2.44.48 PM(3).jpeg',
'assets/img/bg/WhatsApp Image 2025-09-08 at 2.44.48 PM(2).jpeg',
'assets/img/bg/WhatsApp Image 2025-09-08 at 2.44.48 PM(1).jpeg',
'assets/img/bg/WhatsApp Image 2025-09-08 at 2.44.48 PM.jpeg',
'assets/img/bg/WhatsApp Image 2025-09-08 at 2.44.47 PM(8).jpeg',
'assets/img/bg/WhatsApp Image 2025-09-08 at 2.44.47 PM(7).jpeg',
'assets/img/bg/WhatsApp Image 2025-09-08 at 2.44.47 PM(6).jpeg',
'assets/img/bg/WhatsApp Image 2025-09-08 at 2.44.47 PM(5).jpeg',
'assets/img/bg/WhatsApp Image 2025-09-08 at 2.44.47 PM(4).jpeg',
'assets/img/bg/WhatsApp Image 2025-09-08 at 2.44.47 PM(3).jpeg',
'assets/img/bg/WhatsApp Image 2025-09-08 at 2.44.47 PM(2).jpeg',
'assets/img/bg/WhatsApp Image 2025-09-08 at 2.44.47 PM(1).jpeg',
'assets/img/bg/WhatsApp Image 2025-09-08 at 2.44.47 PM.jpeg',
'assets/img/bg/WhatsApp Image 2025-09-08 at 2.44.46 PM(2).jpeg',
'assets/img/bg/WhatsApp Image 2025-09-08 at 2.44.46 PM(1).jpeg',
'assets/img/bg/WhatsApp Image 2025-09-08 at 2.44.46 PM.jpeg',
];

  const styles = {
    sectionLight: {
      padding: "60px 0",
      backgroundColor: "#f8f9fa",
      overflow: "hidden",
    },
    track: {
      display: "flex",
      width: "max-content",
      animation: "scroll 25s linear infinite",
    },
    trackPaused: {
      animationPlayState: "paused",
    },
    clientLogoContainer: {
      flex: "0 0 auto",
      width: "150px",
      padding: "0 30px",
      cursor: "pointer",
    },
    clientLogo: {
      maxHeight: "60px",
      width: "100%",
      objectFit: "contain",
      filter: "grayscale(100%)",
      opacity: 0.7,
      transition: "all 0.3s ease",
    },
    clientLogoHover: {
      filter: "grayscale(0%)",
      opacity: 1,
      transform: "scale(1.1)",
    },
  };

  return (
    <>
      <section style={styles.sectionLight}>
        <div className="container">
          <div className="tp-section-wrapper text-center mb-4">
            <h6 className="tp-section-subtitle mb-25">Our Partners</h6>
            <h2 className="tp-section-title">Our Esteemed Clients</h2>
          </div>

          {/* SLIDER */}
          <div style={{ overflow: "hidden", width: "100%",padding:"10px" }}>
            <div
              style={{
                ...styles.track,
                ...(hoveredClient !== null ? styles.trackPaused : {}),
              }}
            >
              {/* Duplicate logos twice for seamless looping */}
              {clientLogos.concat(clientLogos).map((logo, index) => (
                <div
                  key={index}
                  style={styles.clientLogoContainer}
                  onMouseEnter={() => setHoveredClient(index)}
                  onMouseLeave={() => setHoveredClient(null)}
                >
                  <img
                    src={logo}
                    alt={`Client Logo ${index + 1}`}
                    style={{
                      ...styles.clientLogo,
                      ...(hoveredClient === index ? styles.clientLogoHover : {}),
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* KEYFRAMES */}
      <style>
        {`
          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); } 
          }
        `}
      </style>
    </>
  );
};

export default Ourclient;
